/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';
import AlertMessage from './AlertMessage';
import AlertGoToAction from './AlertGoToAction';
import { alertModel } from '../AlertPropTypes';

import styles from './AlertContainer.scss';

const alertContainerClassName = styles.alertContainerClassName.replace(/"/g, '');

function isEmpty(item) {
	return item === undefined || item === null || item === '';
}

function isActionEmpty(alert) {
	return (
		!alert ||
		!alert.action ||
		(isEmpty(alert.action.label) && isEmpty(alert.action.id) && isEmpty(alert.action.url))
	);
}
export default function AlertContainer(props) {
	const { alert, className, onDismiss, onGoToAction } = props;

	return (
		<div className={`${className} ${alertContainerClassName}`}>
			{alert && <AlertMessage alert={alert} onDismiss={onDismiss} />}
			{!isActionEmpty(alert) && (
				<AlertGoToAction action={alert.action} onGoToAction={onGoToAction} />
			)}
		</div>
	);
}

AlertContainer.propTypes = {
	alert: alertModel,
	className: PropTypes.string,
	onDismiss: PropTypes.func,
	onGoToAction: PropTypes.func,
};

AlertContainer.defaultProps = {
	className: '',
};
